import React, { useState } from "react"

import { Formik, Field } from "formik"
import { FormBox } from "./form/form-box"
import { gql, useMutation } from "@apollo/client"
import { initialRegisterValues, YupRegisterValidation } from "./form/validation"
// import ReCAPTCHA from "react-google-recaptcha"

const SUBMIT_QUERY_INVESTOR = gql`
mutation investorRelations(
    $firstName: String,
    $lastName: String,
    $companyName: String,
    $phoneNumber: String,
    $email: String,
    $address: String,
    $city: String,
    $country: String,
    $subject: String,
    $message: String,
    $salutations: String
  ) {
    submitFormInvestorsRelations(input: {
      address: $address,
      city: $city,
      companyName: $companyName,
      country: $country,
      email: $email,
      firstName: $firstName,
      lastName: $lastName,
      message: $message,
      phoneNumber: $phoneNumber,
      salutations: $salutations,
      subject: $subject
    }) {
      message
      status
    }
  }
  
`

export const InvestorsRelationsForms = ({ lang }) => {
    const [submitData, { data: result, loading }] = useMutation(SUBMIT_QUERY_INVESTOR)

    const [radioData, setRadioData] = useState("Mr")
    const [successSubmit, setSuccessSubmit] = useState(false)

    const handleRadio = (value) => {
        setRadioData(value)
    }


    //Handle from formik
    const handleSubmit = (values, { setSubmitting, resetForm }) => {
        const sendData = {
            ...values,
            salutations: radioData,
        }

        submitData({
            variables: { ...sendData },
        }).then(res => {
            setSubmitting(false);
            setSuccessSubmit(true)
            resetForm()
        }).catch(err => {
            console.log('failed!', err)
        })
    }


    return (
        <section className="pb-main sc-investorsRelations-forms">
            <div className="container mw-xl">
                <Formik
                    initialValues={initialRegisterValues}
                    validationSchema={YupRegisterValidation}
                    onSubmit={handleSubmit}
                >
                    {props => <FormBox {...props} handleRadio={handleRadio} successSubmit={successSubmit} lang={lang} />}
                    {/* <Field name="recaptcha">
                        {({ field, form }) => (
                            <ReCAPTCHA
                                sitekey={process.env.GATSBY_CAPTHA_KEY}
                                onChange={(value) => {
                                    form.setFieldValue("recaptcha", value)
                                }}
                            />
                        )}
                    </Field> */}
                </Formik>
            </div>
        </section>
    )
}